import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBan,
  faBook,
  faCalculator,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDot,
  faCircleExclamation,
  faCircleInfo,
  faClock,
  faCode,
  faCopy,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faFileArrowDown,
  faFileCirclePlus,
  faFileLines,
  faGear,
  faHashtag,
  faLink,
  faMagnifyingGlass,
  faMapLocationDot,
  faMicrophone,
  faMinus,
  faPaperclip,
  faPaperPlane,
  faPen,
  faPhone,
  faPlus,
  faPowerOff,
  faQrcode,
  faReply,
  faRobot,
  faRotateLeft,
  faSearch,
  faShare,
  faShareNodes,
  faSquare,
  faSquareCheck,
  faStop,
  faSliders,
  faTimes,
  faToggleOn,
  faToggleOff,
  faTrash,
  faTriangleExclamation,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserGear,
  faVideo,
  faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as faCircleRegular,
  faCopy as faCopyRegular,
  faSquare as faSquareRegular,
  faWindowMaximize,
} from '@fortawesome/free-regular-svg-icons';

import {
  faWhatsapp as faWhatsApp,
  faFacebookF as faFacebook,
  faInstagram,
  faTiktok as faTikTok,
} from '@fortawesome/free-brands-svg-icons';

library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faArrowsRotate);
library.add(faArrowUpRightFromSquare);
library.add(faBan);
library.add(faBook);
library.add(faCalculator);
library.add(faCheck);
library.add(faCheckDouble);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCircle);
library.add(faCircleRegular);
library.add(faCircleCheck);
library.add(faCircleDot);
library.add(faCircleExclamation);
library.add(faCircleInfo);
library.add(faClock);
library.add(faCode);
library.add(faCopy);
library.add(faCopyRegular);
library.add(faDownLeftAndUpRightToCenter);
library.add(faDownload);
library.add(faFileArrowDown);
library.add(faFileCirclePlus);
library.add(faFileLines);
library.add(faGear);
library.add(faHashtag);
library.add(faLink);
library.add(faMagnifyingGlass);
library.add(faMapLocationDot);
library.add(faMicrophone);
library.add(faMinus);
library.add(faPaperclip);
library.add(faPaperPlane);
library.add(faPen);
library.add(faPhone);
library.add(faPlus);
library.add(faPowerOff);
library.add(faQrcode);
library.add(faReply);
library.add(faRobot);
library.add(faRotateLeft);
library.add(faSearch);
library.add(faShare);
library.add(faShareNodes);
library.add(faSquare);
library.add(faSquareCheck);
library.add(faStop);
library.add(faSquareRegular);
library.add(faSliders);
library.add(faTimes);
library.add(faToggleOn);
library.add(faToggleOff);
library.add(faTrash);
library.add(faTriangleExclamation);
library.add(faUpRightAndDownLeftFromCenter);
library.add(faUser);
library.add(faUserGear);
library.add(faVideo);
library.add(faWindowMaximize);
library.add(faWindowMinimize);

library.add(faFacebook);
library.add(faInstagram);
library.add(faTikTok);
library.add(faWhatsApp);
